function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-805-740h1920v2223H-805z"
}), React.createElement("path", {
  d: "M-805-383h1920v1845H-805z"
}), React.createElement("g", {
  transform: "translate(-70 -52)"
}, React.createElement("path", {
  d: "M109.315 64.547c.35 0 .699.262.786.61l1.543 4.63h4.658a3.503 3.503 0 0 1 3.493 3.493v29.691a3.504 3.504 0 0 1-2.09 3.197l7.854 5.711c.349.262.436.611.349.96-.175.35-.524.612-.873.612H84.863a.839.839 0 0 1-.786-.611.986.986 0 0 1 .262-.96l7.423-5.94a3.499 3.499 0 0 1-1.66-2.969V73.28a3.503 3.503 0 0 1 3.494-3.494h4.658l1.542-4.628a.839.839 0 0 1 .786-.611zm1.747 45.41h-13.1v1.748h13.1v-1.747zm-14.846 0h-6.637l-2.183 1.748h8.82v-1.747zm23.579-.17v.17h-6.987v1.747h9.607l-2.62-1.917zm-8.733-3.322h-13.1v1.746h13.1v-1.746zm-14.846 0h-2.27l-2.184 1.746h4.454v-1.746zm19.038 0h-2.446v1.746h4.833l-2.387-1.746zm2.794-10.48H91.85v6.986c0 .961.786 1.747 1.747 1.747h22.706c.96 0 1.746-.786 1.746-1.747v-6.986zm-21.832 1.747c1.485 0 2.62 1.135 2.62 2.62 0 1.484-1.135 2.62-2.62 2.62s-2.62-1.136-2.62-2.62c0-1.485 1.135-2.62 2.62-2.62zm17.466 0c1.484 0 2.62 1.135 2.62 2.62 0 1.484-1.136 2.62-2.62 2.62-1.485 0-2.62-1.136-2.62-2.62 0-1.485 1.135-2.62 2.62-2.62zm-17.466 1.746c-.524 0-.873.35-.873.874s.349.873.873.873.873-.35.873-.873c0-.524-.35-.874-.873-.874zm17.466 0c-.524 0-.874.35-.874.874s.35.873.874.873.873-.35.873-.873c0-.524-.35-.874-.873-.874zm4.366-17.466H91.85V94.24h26.2V82.012zm-1.746-10.48H93.596c-.96 0-1.747.787-1.747 1.748v6.986h26.2V73.28c0-.961-.787-1.747-1.747-1.747zm-5.24 1.748c.524 0 .873.349.873.873v3.493c0 .524-.35.873-.873.873H98.836c-.524 0-.873-.35-.873-.873v-3.493c0-.524.349-.873.873-.873zm-.873 1.746h-10.48v1.747h10.48v-1.747zm-1.485-8.733h-7.51l-1.136 3.493h9.781l-1.135-3.493z",
  fill: "currentColor"
})), React.createElement("text", {
  fontFamily: "BNPPSans, BNPP Sans",
  fontSize: 16,
  transform: "translate(-70 -56.72)"
}, React.createElement("tspan", {
  x: 73.656,
  y: 138.719
}, "Kolejowy")));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 70,
    height: 71
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pociogowy.df738d10.svg";
export { SvgComponent as ReactComponent };